import * as React from 'react';

import * as styles from './FavoritesWidgetWrapper.css';

interface IFavoritesFoldersProps {
  children: React.ReactNode;
}

export function FavoritesWidgetWrapper({ children }: IFavoritesFoldersProps) {
  return <div className={styles['container']}>{children}</div>;
}
